export const categoryLabels: Record<string, string> = {
  VERTRAG: 'Verträge',
  NACHWEIS: 'Nachweise',
  UNTERLAGEN: 'Unterlagen',
  FORMULAR: 'Formulare',
  ANSCHREIBEN: 'Anschreiben',
  DATENSCHUTZ: 'Datenschutz',
};

export const categoryOrder = ['VERTRAG', 'NACHWEIS', 'UNTERLAGEN', 'FORMULAR', 'ANSCHREIBEN', 'DATENSCHUTZ'];

export const statusLabels: Record<string, string> = { DRAFT: 'Entwurf', FINAL: 'Fertig' };
